import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Select, message } from "antd";
import { fetchBrandsBySelectedClients } from "../../core/api/settings";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { syncStockData } from "../../core/api/report";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { fetchStockDataByBrandId } from "../../core/api/report";
import { secureExportToExcel } from "../../utils/secureExcelUtils";
import { getCurrentUser } from "../../core/api/settings";
import { getProfileTest} from "../../core/api/auth.js";

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const StockData = () => {
  const handleSyncStockData = async () => {
    setLoading(true);
    try {
      await syncStockData(selectedBrand);
      message.success("Stock data synced.");
      fetchData();
    } catch (err) {
      message.error("Failed to sync stock data.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const profile = useSelector((state) => state.profile);
  console.log("Profile in StockData component:",profile);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [lastSynced, setLastSynced] = useState(null);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);  

  useEffect(() => {
    setBrands([]);
    setSelectedBrand(null);
    fetchBrandsBySelectedClients(selectedClients)
      .then((res) => {
        if (!res.data || res.data.length === 0) return;

        setBrands(res.data);
        if (res.data.length === 1) {
          const autoSelectedBrand = res.data[0].id;
          setSelectedBrand(autoSelectedBrand);
        }
        setLoadingBrands(false);
      })
      .catch(() => {
        setLoadingBrands(false);
        message.error("Failed to fetch brands.");
      });
  }, [selectedClients]);

  const fetchData = () => {
    fetchStockDataByBrandId(selectedBrand)
      .then((res) => {
        if (!res.data || res.data.length === 0) {
          message.warning("No data found for this brand.");
          setRowData([]);
          setLoading(false);
          return;
        }

        setRowData(res.data);
        setLoading(false);
        setLastSynced(res.data[0].last_synced);
      })
      .catch(() => {
        message.error("Failed to fetch sales data.");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!selectedBrand) return;
    setLoading(true);

    fetchData();
  }, [selectedBrand]);

  useEffect(() => {
    const fetchPermissions = async () => {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");
      if (token) {
        try {
          sessionStorage.setItem(
            "page_permissions",
            JSON.stringify(profile?.page_permissions)
          );
          sessionStorage.setItem(
            "page_authorization",
            JSON.stringify(profile?.page_authorization)
          );
          sessionStorage.setItem("user_role", profile?.role);
        } catch (e) {
          console.error("Failed to fetch permissions", e);
        }
      }
    };
    fetchPermissions();
  }, [profile]);

  const pagePermissions = sessionStorage.getItem("page_permissions") || "";
  const pageAuthorizations = sessionStorage.getItem("page_authorization") || "";
  const userRole = sessionStorage.getItem("user_role");

  const canAddStock =
    userRole === "admin" ||
    userRole === "super_admin" ||
    pageAuthorizations.includes("/stock-data_create/*");
  const canEditock =
    userRole === "admin" ||
    userRole === "super_admin" ||
    pageAuthorizations.includes("/stock-data_edit/*");
  const canDeleteStock =
    userRole === "admin" ||
    userRole === "super_admin" ||
    pageAuthorizations.includes("/stock-data_delete/*");
  const canDownloadStock =
    userRole === "admin" ||
    userRole === "super_admin" ||
    pageAuthorizations.includes("/stock-data_download/*");

  const columns = useMemo(() => {
    if (rowData.length === 0) return [];
    return Object.keys(rowData[0])
      .filter((key) => !["id", "brand", "file"].includes(key))
      .map((key) => ({
        headerName: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        field: key,
        sortable: true,
        filter: true,
        resizable: true,
      }));
  }, [rowData]);

  const exportToExcel = () => {
    if (rowData.length === 0) {
      message.warning("No data available to export");
      return;
    }

    const exportData = rowData.map((item) => {
      const row = {};
      columns.forEach((col) => {
        row[col.headerName] = item[col.field] || "";
      });
      return row;
    });

    const brandName =
      brands.find((b) => b.id === selectedBrand)?.brand_name || "stock";
    secureExportToExcel(exportData, `${brandName}_stock_data.xlsx`);
  };


  
  return (
    <div className="">
      <div className="">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock Data</h4>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
              <p className="text-gray-600 text-lg font-medium me-2">
                Last Synced on:{" "}
                <span className="font-semibold text-gray-900">
                  {lastSynced ? new Date(lastSynced).toLocaleString() : "-"}
                </span>
              </p>
            </li>
            <li>
              <Select
                placeholder="Select Brand"
                options={brands.map((brand) => ({
                  value: brand.id,
                  label: brand.brand_name,
                }))}
                onChange={(value) => setSelectedBrand(value)}
                value={selectedBrand}
                loading={loadingBrands}
              />
            </li>
            
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Excel</Tooltip>}>
                  <Link onClick={exportToExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/xls.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Refresh & Sync ShipStation</Tooltip>}>
                <Link onClick={handleSyncStockData}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}>
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}>
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        {/* Ag-Grid Table */}
        <div className="card table-list-card">
          <div
            className="ag-theme-quartz"
            style={{ height: "700px", width: "100%" }}>
            <AgGridReact
              columnDefs={columns}
              rowData={rowData}
              defaultColDef={{ flex: 1, minWidth: 100 }}
              pagination={false}
              loading={loading}
              enableCellTextSelection={true}
              ensureDomOrder={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockData;
